"use client";

import { Provider } from "react-redux";
import { store } from "@/redux/stores/store";
import ThemeRegistry from "./theme-registry";
import { SnackbarProviderWrapper } from "@/components/StackAlerts/SnackbarProviderWrapper";
import { SnackbarListener } from "@/components/StackAlerts/SnackbarListener";
import { LoadingProvider } from "@/components/LoadingProvider";
import { Suspense } from "react";

export default function Providers({ children }) {
  return (
    <Suspense fallback={null}>
      <Provider store={store}>
        <ThemeRegistry>
          <SnackbarProviderWrapper>
            <LoadingProvider>
              <SnackbarListener />
              {children}
            </LoadingProvider>
          </SnackbarProviderWrapper>
        </ThemeRegistry>
      </Provider>
    </Suspense>
  );
}